export default "__VITE_ASSET__$WxHpg7w__"